import { routes as accountRoutes } from '@cobliteam/account';

// Use the routes directly from the account module
const routes = [...accountRoutes];

export default routes;
